import { useState, useRef } from "react";
import { useBlocker } from "react-router-dom";

/**
 * Safely blocks navigation when unsaved changes exist.
 */

// TODO: Move this component to be reusable globally
// TODO:Finish up with fixing the errors for the "unsaved" modal
export const useUnsavedChangesPrompt = (shouldBlock) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [pendingTx, setPendingTx] = useState(null);
  const skipBlock = useRef(false);

  const blocker = useBlocker(({ retry }) => {
    if (shouldBlock && !skipBlock.current) {
      setShowPrompt(true);
      setPendingTx(() => retry);
      return true;
    }
    return false;
  }, shouldBlock);

  const confirmNavigation = () => {
    if (pendingTx) {
      skipBlock.current = true;
      pendingTx();
      setPendingTx(null);
    }
    setShowPrompt(false);

    setTimeout(() => {
      skipBlock.current = false;
    }, 0);
  };

  const cancelNavigation = () => {
    setShowPrompt(false);
    setPendingTx(null);
  };

  return {
    showPrompt,
    confirmNavigation,
    cancelNavigation,
  };
};
